import React, { useEffect, useRef } from "react";

const DoughnutChart = ({corpus, data}) => {
  const canvasRef = useRef(null);
  const chartRef = useRef(null); // To store the chart instance

  useEffect(() => {
    const ctx = canvasRef.current.getContext("2d");

    // Destroy the previous chart instance if it exists
    if (chartRef.current) {
      chartRef.current.destroy();
    }

    // Create a new chart instance and store it in the ref
    chartRef.current = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: ["Pink", "yellow", "purple"],
        datasets: [
          {
            data: data,
            backgroundColor: ["rgba(213, 53, 115, 1)", "rgba(225, 118, 18, 1)", "rgba(173, 66, 239, 1)"],
            borderWidth: 5,
            hoverOffset: 4,
            borderRadius: 70,
          },
        ],
      },
      options: {
        cutout: "80%",
        plugins: {
          legend: { display: false },
          tooltip: { enabled: true },
        },
      },
      plugins: [
        {
          id: "centerText",
          beforeDraw: (chart) => {
            const { width, height } = chart;
            const ctx = chart.ctx;
            ctx.save();

            // Main text
            const fontSizeMain = (height / 150).toFixed(2);
            ctx.font = `${fontSizeMain}em sans-serif`;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillStyle = "#333";
            const mainText = `₹ ${corpus}`;
            ctx.fillText(mainText, width / 2, height / 2);

            // Smaller text
            const fontSizeSmall = (height / 250).toFixed(2);
            ctx.font = `${fontSizeSmall}em sans-serif`;
            const smallText = "Retirement Corpus";
            ctx.fillStyle = "rgb(116, 116, 116)";
            ctx.fillText(smallText, width / 2, height / 2 + 30); // Adjust '20' for vertical spacing

            ctx.restore();
          },
        },
      ],
    });

    // Cleanup function to destroy the chart when the component unmounts
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, []); // Empty dependency array ensures this runs only once

  return <canvas ref={canvasRef}></canvas>;
};

export default DoughnutChart;

